import React, { useState } from 'react';
import { Agreement } from '../../../models/Agreement';
import { Button } from '../../core/button';
import { Field } from '../../core/field';
import Notification from '../../core/notification';
import Popover from '../../core/popover';
import styles from './distribute_agreement_popover.module.scss';
import { distributeAgreementViaSms } from './service';
import { Modal } from '../../core/modal';

type Props = {
  open: boolean;
  onClose: () => void;
  agreement: Agreement;
  onAgreementDistributed?: (phoneNumber: string) => void;
}

/**
 * For choosing how to distribute an agreement.
 */
export const AgreementDistributionPopover: React.FC<Props> = ({
  onClose, open, agreement, onAgreementDistributed
}) => {
  const [recipient, setRecipient] = useState('');
  const [distributingBusy, setDistributingBusy] = useState(false);

  async function distributeAgreement() {
    setDistributingBusy(true);

    try {
      await distributeAgreementViaSms(
        agreement.key,
        recipient.replace(/^0/, '+46'),
      );

      var success = true;
    } catch (e) {
      console.error(e);
      Notification.show(`Kunde inte skicka avtalskopian`);
    }

    if (success) {
      Notification.show(`Skickade avtalskopian`);
      onAgreementDistributed?.(recipient);
    }

    setDistributingBusy(false);
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <div className={styles.content}>
        <div>
          <h3>Skicka avtalskopia</h3>
          <form
            onSubmit={e => {
              e.preventDefault();
              distributeAgreement();
              return false;
            }}>
            <div>
              <Field
                label="Telefonnummer"
                disabled={distributingBusy}
                value={recipient}
                onTextValueChange={recipient => setRecipient(recipient.trim())} />
            </div>

            <Button
              type="submit"
              disabled={distributingBusy}
              weight="primary"
              busy={distributingBusy}>
              Skicka avtal
            </Button>
          </form>
        </div>

        <footer className={styles.footer}>
          Avtalet bifogas i SaleSys-ordern
        </footer>
      </div>
    </Modal>
  )
}